// src/icons/ArrowsHorizontal.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function ArrowsHorizontal({
  strokeWidth = "2",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 22 25",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M16.3846 1L21.0009 5.61631M21.0009 5.61631L16.3846 10.2326M21.0009 5.61631H2.53564",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap,
            strokeLinejoin
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M5.6164 23.0041L1.00009 18.3878M1.00009 18.3878L5.6164 13.7715M1.00009 18.3878L19.4653 18.3878",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap,
            strokeLinejoin
          }
        )
      ]
    }
  );
}

export {
  ArrowsHorizontal
};
